import { I_AND_I_TIME_PERIODS, IAndITimePeriodsValue } from "@/config/date";
import { CUSTOM_FILTERS } from "@/config/list";
import { TimePeriodDropdown } from "@/components/TimePeriod";
import { ListFilters } from "@/types/list";

type TimePeriodFilterProps = {
	filter: ListFilters;
};

export const TimePeriodFilter = ({ filter }: TimePeriodFilterProps) => {
	const value = (filter.getFilter(CUSTOM_FILTERS.timePeriod) as IAndITimePeriodsValue[] | undefined) ?? undefined;
	const timePeriodValue = value?.[0];
	const onChange = (next: IAndITimePeriodsValue) => {
		filter.setFilter(CUSTOM_FILTERS.timePeriod, [next]);
	};

	return (
		<div className="relative z-10">
			<TimePeriodDropdown
				value={timePeriodValue}
				onChange={onChange}
				options={I_AND_I_TIME_PERIODS}
				showLabel={false}
			/>
		</div>
	);
};
